export default {
    name: 'fw-create-measure-dropdown',
    fragment: {
        template: `
        <ribbon-button @controller="selection:SelectionDropdownController" name="create-measurement-button-list" @var.self="$component" @cannotBeDisabled @tooltip tooltip-title="toolbar.buttons.tooltip.distance">
            <dropdown class="fv__ui-dropdown-hide-text" @cannotBeDisabled selected="0" @on.selected="self.select($args[0])">
                <dropdown-button
                    ribbon-text="toolbar.buttons.measure"
                    @tooltip tooltip-title="toolbar.buttons.tooltip.distance"
                    name="create-distance-btn"
                    ribbon-icon="fx-icon-ribbon_comment_measure_distance-32"
                    icon-class="fx-icon-sm fv__icon-toolbar-distance" @controller="distance:CreateDistanceController"
                >
                    toolbar.buttons.distance
                </dropdown-button>
                <dropdown-button ribbon-text="toolbar.buttons.measure" @tooltip tooltip-title="toolbar.buttons.tooltip.perimeter" name="create-perimeter-btn" ribbon-icon="fx-icon-ribbon_comment_measure_perimeter-32" icon-class="fx-icon-sm fv__icon-toolbar-perimeter" @controller="distance:CreatePerimeterController">toolbar.buttons.perimeter</dropdown-button>
                <dropdown-button
                    ribbon-text="toolbar.buttons.measure"
                    @tooltip tooltip-title="toolbar.buttons.tooltip.area"
                    name="create-area-btn"
                    ribbon-icon="fx-icon-ribbon_comment_measure_area-32"
                    icon-class="fx-icon-sm fv__icon-toolbar-area"
                    @controller="distance:CreateAreaController"
                >
                    toolbar.buttons.area
                </dropdown-button>
                <dropdown-button ribbon-text="toolbar.buttons.measure" @tooltip tooltip-title="toolbar.buttons.tooltip.circleArea" name="create-circle-area-btn" ribbon-icon="fx-icon-ribbon_areacircle-32" icon-class="fx-icon-sm fv__icon-toolbar-areacircle" @controller="distance:CreateCircleAreaController">toolbar.buttons.area</dropdown-button>
            </dropdown>
        </ribbon-button>
        `
    }
};